import getAttachmentPdfPreviewResponse from '../services/getAttachmentPdfPreviewResponse';
import { ClientAttachmentId } from 'owa-client-ids';

export default async function getAttachmentPdfPreview(
    attachmentId: ClientAttachmentId
): Promise<GetAttachmentPdfPreviewResponseData> {
    const response: Response = await getAttachmentPdfPreviewResponse(
        attachmentId.mailboxInfo?.routingKey,
        attachmentId.Id
    );
    if (response.ok) {
        const responseText = await response.text();
        const base64encoded = responseText.replace(/\s/gi, ''); // removes any newline and space
        const decoded = atob(base64encoded);
        const decodedLength = decoded.length;
        const array = new Uint8Array(new ArrayBuffer(decodedLength));

        for (let i = 0; i < decodedLength; i++) {
            array[i] = decoded.charCodeAt(i);
        }

        const printAllowed = response.headers.get('PrintAllowed');
        const copyAllowed = response.headers.get('CopyAllowed');
        const exportAllowed = response.headers.get('ExportAllowed');

        return {
            data: array,
            printAllowed: !printAllowed || printAllowed.toLowerCase() === 'true',
            copyAllowed: !copyAllowed || copyAllowed.toLowerCase() === 'true',
            exportAllowed: !exportAllowed || exportAllowed.toLowerCase() === 'true',
        };
    }

    throw response.statusText;
}

interface GetAttachmentPdfPreviewResponseData {
    data: Uint8Array;
    printAllowed: boolean;
    copyAllowed: boolean;
    exportAllowed: boolean;
}
